
(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    function DocumentListViewModel() {

        // Self-Identification
        self = this;

        // Checklist Form Values
        this.AllTestScoreTemplate = ko.observable('');
        this.AcceptAndDeclineButton = ko.observable('');
        this.RequiredDocumentTemplate = ko.observable('');
        this.AdmissionsAttemptGid = ko.observable();
        this.ExpectedEntrancePeriod = ko.observable();
        this.DeliveryMethod = ko.observable();
        this.AdmissionsType = ko.observable();
        this.AdmissionsStage = ko.observable();
        this.AdmissionsStatus = ko.observable();
        this.ShowAdmissionsStage = ko.observable();
        this.ShowAdmissionsStatus = ko.observable();
        this.DisplayName = ko.observable();
        this.Program = ko.observable();
        this.EntryPoint = ko.observable();
        this.SubmittedStatusName = ko.observable();

        this.CurrentAdmissionStageHasOffer = ko.observable(false);
        this.StudentHasAcceptedOffer = ko.observable(false);
        this.StudentHasDeniedOffer = ko.observable(false);
        this.IsConfirmPopupEnabled = ko.observable();

        this.AdmissionsRecords = ko.observable();
        this.AdmissionsRecordID = ko.observable();
        this.ACTScore = ko.observableArray();
        this.HighSchoolInformation = ko.observableArray();
        this.CollegeInformation = ko.observableArray();
        this.TranscriptGradeEvaluation = ko.observableArray();
        this.TranscriptGradeEvaluationName = ko.observable();
        this.TranscriptGradeEvaluationStatus = ko.observable();
        this.SATScore = ko.observableArray();
        this.PraxisScore = ko.observableArray();
        this.PraxisIIScore = ko.observableArray();
        this.TOEFL = ko.observableArray();
        this.GEDScore = ko.observableArray();
        this.GREScore = ko.observableArray();
        this.GMATScore = ko.observableArray();
        this.ApplicationFee = ko.observableArray();
        this.DepositFee = ko.observableArray();
        this.IsDepositPayment = ko.observable(false);
        this.CollegeReleaseForm = ko.observableArray();
        this.Form48C = ko.observableArray();
        this.Immunizations = ko.observableArray();
        this.CodeOfConduct = ko.observableArray();
        this.I94Copy = ko.observableArray();
        this.VisaCopy = ko.observableArray();
        this.PassportCopy = ko.observableArray();
        this.AffidavitofSupport = ko.observableArray();
        this.BankStatement = ko.observableArray();
        this.TuitionForm = ko.observableArray();
        this.VisaCompliance = ko.observableArray();
        this.PermanentResidenceCard = ko.observableArray();
        this.LegalStatus = ko.observableArray();
        this.TransferForm = ko.observableArray();
        this.I20 = ko.observableArray();
        this.DS2019 = ko.observableArray();
        this.FormI539 = ko.observableArray();
        this.FormI540 = ko.observableArray();
        this.LetterfromPetitioner = ko.observableArray();
        this.LetterfromSponsor = ko.observableArray();
        this.COSFeePoP = ko.observableArray();
        this.SEVISFeePoP = ko.observableArray();
        this.Recommendations = ko.observableArray();
        this.Resume = ko.observableArray();
        this.Interview = ko.observableArray();
        this.RetentionStatement = ko.observableArray();
        this.TeachingCertificate = ko.observableArray();
        this.UGMajorContentApproval = ko.observableArray();
        this.ProgramPlanningConference = ko.observableArray();
        this.WritingAssessment = ko.observableArray();
        this.Form = ko.observableArray();
        this.GoalsObjectives = ko.observableArray();
        this.ContinuingEdForm = ko.observableArray();
        this.AdmissionsDocuments = ko.observableDictionary();
        this.AdmissionsOffer = ko.observableDictionary();
        this.AdmissionOfferRichText = ko.observable('');
        this.IsEmptyRichText = ko.observable(true);

        this.AttendanceStatuses = ko.observableArray([]);
        this.selectDoc = ko.observable();
        this.AdmissionsDocs = ko.observableArray([]);

        this.DocumentFile = ko.observable();
        this.DocumentUrl = ko.observable();
        this.filename = ko.observable("");
        this.highSchoolFile = ko.observable();
        this.collegeFile = ko.observable();
        this.immunizationFile = ko.observable();
        this.releaseFile = ko.observable();
        this.form48File = ko.observable();
        this.conductFile = ko.observable();
        this.i94File = ko.observable();
        this.visaFile = ko.observable();
        this.passportFile = ko.observable();
        this.supportFile = ko.observable();
        this.bankFile = ko.observable();
        this.tuitionFile = ko.observable();
        this.complianceFile = ko.observable();
        this.residentFile = ko.observable();
        this.legalFile = ko.observable();
        this.transferFile = ko.observable();
        this.i20File = ko.observable();
        this.ds2019File = ko.observable();
        this.i539File = ko.observable();
        this.i540File = ko.observable();
        this.petitionFile = ko.observable();
        this.sponsorFile = ko.observable();
        this.cosFeeFile = ko.observable();
        this.sevisFeeFile = ko.observable();
        this.recommendationFile = ko.observable();
        this.resumeFile = ko.observable();
        this.interviewFile = ko.observable();
        this.retentionFile = ko.observable();
        this.teachingCertFile = ko.observable();
        this.ugMajorFile = ko.observable();
        this.programPlanFile = ko.observable();
        this.writingFile = ko.observable();
        this.formFile = ko.observable();
        this.goalsFile = ko.observable();
        this.edFormFile = ko.observable();
        this.admissionsDocFile = ko.observable();
        this.IsPaymentProviderEnabled = ko.observable(false);
        this.IsBackgroundProcessing = ko.observable(false);
        this.IsBackgroundProcessingError = ko.observable(false);
        this.PaymentProviderName = ko.observable();
        this.PaymentDetails = ko.observable();
        //Domicile related observables
        this.IsBillingDomicileMappingCorrect = ko.observable(false);
        this.BillingDomicileMessage = ko.observable("");
        this.IsBillingDomicilePaymentProviderEnabled = ko.observable(false);
        this.BillingDomicilePaymentProviders = ko.observableArray();
        this.PartialPaymentAmount = ko.observable();
        this.MinimumAmountForPayments = ko.observable();
        this.EnablePartialPayment = ko.observable();
        this.SelectedPaymentProviderId = ko.observable();

        this.IsPaid = ko.observable(false);
        this.IsDepositPaid = ko.observable(false);
        this.TermsAndCondition = ko.observable();
        this.TermsAndConditionLoaded = ko.observable(false);
        this.TemplatesLoaded = ko.observable(false);
        this.AdmissionsAdditionalInformations = ko.observableArray();
        this.SubmittedWithPostSubmissionFlowCustom = ko.observable(false);

        // Error Handling
        this.ErrorHeader = ko.observable();
        sm.portal.vm.custom.callCustomization('CustomizedErrorHeader',self);
        this.ErrorMessages = ko.observableArray();
        this.IsError = ko.observable();
        this.IsGeneralError = ko.observable();

        // Information Messages Handling
        this.Header = ko.observable();
        this.Messages = ko.observableArray();
        this.ShowMessages = ko.observable(false);
        
        this.ShowCongratulationsID = ko.observable('');
        this.ShowLabelID = ko.observable('');
        this.ShowCustomField =  ko.observable(false);
        this.AdmissionsProcess = ko.observable('');
        this.HidePaymentInfoSec = ko.observable(true); 
        this.RequiredDocumentsText = ko.observable(sm.portal.utility.getResourceValue('RequiredDocuments'));
        this.HeaderText = ko.observable();
        this.HeaderTextVisible = ko.observable();
        this.AcceptButtonText = ko.observable();
        this.DeclineButtonText = ko.observable();
        this.AcceptButtonHoverTxt = ko.observable("");
        this.DeclineButtonHoverTxt = ko.observable("");
		this.PostAcceptanceText = ko.observable();
        this.PostAcceptanceTextVisible = ko.observable();
        this.PostDeclineText = ko.observable();
        this.PostDeclineTextVisible = ko.observable();
        this.ExpandInitial = ko.observable();
        this.OfferingItem = ko.observable();
        this.DisplayAPOI = ko.observable();
        sm.portal.vm.custom.setCustomLocalizeKey(self);

        this.AllAdmissionsRecords = ko.observableArray();
        this.CheckAdmissionDocumentStatus = function (data) {
            var status = sm.portal.vm.custom.callCustomization('CheckDocumentStatus', data);
            if (sm.portal.utility.isNullOrEmpty(status)) {
                if (data.StatusBusinessMeaningName == 'ApplicationProcessStepStatus.Complete') {
                    status = true;
                }
                else
                    status = false;
            }

            return status;
        }

        this.CheckTranscriptStatus = function(status) {
            if (status == 'Complete') {
                return true;
            }
            else {
                return false;
            }
        }

        this.GetRichTextStatus = function(value){
            var richTextHTML = jQuery.parseHTML(value);
            if (richTextHTML && richTextHTML.length < 2 && richTextHTML[0] && richTextHTML[0].nodeName == 'P' &&  !richTextHTML[0].innerText){
                self.IsEmptyRichText(true);
            }else{
                self.IsEmptyRichText(false);
            }
        }

        sm.portal.utility.get('api/portalstudentledger/MinimumAmountForPayments', function (output) {
            self.MinimumAmountForPayments(output);
        });

        sm.portal.utility.get('api/portalstudentledger/EnablePartialPayment', function (output) {
            self.EnablePartialPayment(output);           
        });

        this.HandleEncryptedRichText = function(encryptedText, showDecryptedText, decryptedText) {
            // decryptedText is ko observable that would hold the decrypted rich text
            // showDecryptedText is the ko observable to make sure the decrypted text is shown only if it has valid text

            var encryptedTextBytes = atob(encryptedText);
            var encryptedRichText = new TextDecoder("utf-8").decode(new Uint8Array([...encryptedTextBytes].map(char => char.charCodeAt(0))));

            let myElement = new DOMParser().parseFromString(encryptedRichText, 'text/html');
            myElement.querySelectorAll('table').forEach(table => table.classList.add('richTextContentTable') )
            myElement.querySelectorAll('ul li').forEach(li => li.style.listStyleType = 'disc');
            myElement.querySelectorAll('ul').forEach(ul => {
                ul.style.paddingLeft = '40px'
                ul.style.wordBreak = 'break-word';
            });
            myElement.querySelectorAll('ol').forEach(ol => ol.style.wordBreak = 'break-word');

            var processedRichTextHTML = Array.from(myElement.querySelectorAll('body')).map((p) => {
                showDecryptedText(p.innerText.trim() != '');
                return p.innerHTML;
            });

            decryptedText(processedRichTextHTML);
        }

        // Handlers
        this.LoadModel = function (container) {


            var customData = {
                self: self,
                container: container
            }
            var flag = sm.portal.vm.custom.callCustomization('DocumentListLoadModelCustom',customData);
            if(!sm.portal.utility.isNullOrEmpty(flag)){
                return;
            }

            // Set the main Entity
            var entity = container.Payload.Entity;

            if (entity) {
                this.AdmissionsAttemptGid = ko.observable(entity.GID);
            }

            this.ExpectedEntrancePeriod(container.Payload.ExpectedEntrancePeriod);
            this.DeliveryMethod(container.Payload.DeliveryMethod);
            this.AdmissionsType(container.Payload.AdmissionsType);
            this.AdmissionsStage(container.Payload.AdmissionsStage);
            this.AdmissionsStatus(container.Payload.AdmissionsStatus);
            this.ShowAdmissionsStage(container.Payload.ShowAdmissionsStage);
            this.ShowAdmissionsStatus(container.Payload.ShowAdmissionsStatus);
            this.AdmissionsRecords(container.Payload.AdmissionsRecords);
            this.SubmittedStatusName(container.Payload.SubmittedStatusName);

            this.IsConfirmPopupEnabled(container.Payload.IsConfirmPopupEnabled);
            this.CurrentAdmissionStageHasOffer(container.Payload.CurrentAdmissionStageHasOffer);
            this.StudentHasAcceptedOffer(container.Payload.StudentHasAcceptedOffer);
            this.StudentHasDeniedOffer(container.Payload.StudentHasDeniedOffer);

            if (currentLoaded == 0 && !sm.portal.utility.isNullOrEmpty(this.AdmissionsRecords())) {
                currentLoaded = this.AdmissionsRecords()[0].ID;
            }

            if (container.Payload.ACTScore)
                this.ACTScore(container.Payload.ACTScore);
            if (container.Payload.HighSchoolInformation)
                this.HighSchoolInformation(container.Payload.HighSchoolInformation);
            if (container.Payload.CollegeInformation)
                this.CollegeInformation(container.Payload.CollegeInformation);
            if (container.Payload.TranscriptGradeEvaluation) {
                this.TranscriptGradeEvaluationName(container.Payload.TranscriptGradeEvaluation.DocumentName);
                this.TranscriptGradeEvaluationStatus(container.Payload.TranscriptGradeEvaluation.Status);
                if (container.Payload.TranscriptGradeEvaluation.AdmissionsRequirementGroups) {
                    const transcriptWithDefaultStatus = this.SetDefaultStatusTranscript(container.Payload.TranscriptGradeEvaluation);
                    const modifiedData = this.DataSetupTranscriptGradeEvaluation(transcriptWithDefaultStatus);
                    const modifiedWithRule = this.AssignRuleTypeMergeSubGroupToCourse(modifiedData);
                    this.TranscriptGradeEvaluation(modifiedWithRule.AdmissionsRequirementGroups);
                }else {
                    this.TranscriptGradeEvaluation([]);
                }
            }
            if (container.Payload.SATScore)
                this.SATScore(container.Payload.SATScore);
            if (container.Payload.PraxisScore)
                this.PraxisScore(container.Payload.PraxisScore);
            if (container.Payload.PraxisIIScore)
                this.PraxisIIScore(container.Payload.PraxisIIScore);
            if (container.Payload.TOEFL)
                this.TOEFL(container.Payload.TOEFL);
            if (container.Payload.GEDScore)
                this.GEDScore(container.Payload.GEDScore);
            if (container.Payload.GREScore)
                this.GREScore(container.Payload.GREScore);
            if (container.Payload.GMATScore)
                this.GMATScore(container.Payload.GMATScore);
            if (container.Payload.ApplicationFee)
                this.ApplicationFee(container.Payload.ApplicationFee);
            if (container.Payload.DepositFee)
                this.DepositFee(container.Payload.DepositFee);
                this.IsDepositPayment(false);
            if (container.Payload.Immunizations)
                this.Immunizations(container.Payload.Immunizations);
            if (container.Payload.I94Copy)
                this.I94Copy(container.Payload.I94Copy);
            if (container.Payload.CollegeReleaseForm)
                this.CollegeReleaseForm(container.Payload.CollegeReleaseForm);
            if (container.Payload.Form48C)
                this.Form48C(container.Payload.Form48C);
            if (container.Payload.CodeOfConduct)
                this.CodeOfConduct(container.Payload.CodeOfConduct);
            if (container.Payload.VisaCopy)
                this.VisaCopy(container.Payload.VisaCopy);
            if (container.Payload.PassportCopy)
                this.PassportCopy(container.Payload.PassportCopy);
            if (container.Payload.AffidavitofSupport)
                this.AffidavitofSupport(container.Payload.AffidavitofSupport);
            if (container.Payload.BankStatement)
                this.BankStatement(container.Payload.BankStatement);
            if (container.Payload.TuitionForm)
                this.TuitionForm(container.Payload.TuitionForm);
            if (container.Payload.VisaCompliance)
                this.VisaCompliance(container.Payload.VisaCompliance);
            if (container.Payload.PermanentResidenceCard)
                this.PermanentResidenceCard(container.Payload.PermanentResidenceCard);
            if (container.Payload.LegalStatus)
                this.LegalStatus(container.Payload.LegalStatus);
            if (container.Payload.TransferForm)
                this.TransferForm(container.Payload.TransferForm);
            if (container.Payload.I20)
                this.I20(container.Payload.I20);
            if (container.Payload.DS2019)
                this.DS2019(container.Payload.DS2019);
            if (container.Payload.FormI539)
                this.FormI539(container.Payload.FormI539);
            if (container.Payload.FormI540)
                this.FormI540(container.Payload.FormI540);
            if (container.Payload.LetterfromPetitioner)
                this.LetterfromPetitioner(container.Payload.LetterfromPetitioner);
            if (container.Payload.LetterfromSponsor)
                this.LetterfromSponsor(container.Payload.LetterfromSponsor);
            if (container.Payload.COSFeePoP)
                this.COSFeePoP(container.Payload.COSFeePoP);
            if (container.Payload.SEVISFeePoP)
                this.SEVISFeePoP(container.Payload.SEVISFeePoP);
            if (container.Payload.Recommendations)
                this.Recommendations(container.Payload.Recommendations);
            if (container.Payload.Resume)
                this.Resume(container.Payload.Resume);
            if (container.Payload.Interview)
                this.Interview(container.Payload.Interview);
            if (container.Payload.RetentionStatement)
                this.RetentionStatement(container.Payload.RetentionStatement);
            if (container.Payload.TeachingCertificate)
                this.TeachingCertificate(container.Payload.TeachingCertificate);
            if (container.Payload.UGMajorContentApproval)
                this.UGMajorContentApproval(container.Payload.UGMajorContentApproval);
            if (container.Payload.ProgramPlanningConference)
                this.ProgramPlanningConference(container.Payload.ProgramPlanningConference);
            if (container.Payload.WritingAssessment)
                this.WritingAssessment(container.Payload.WritingAssessment);
            if (container.Payload.Form)
                this.Form(container.Payload.Form);
            if (container.Payload.GoalsObjectives)
                this.GoalsObjectives(container.Payload.GoalsObjectives);
            if (container.Payload.ContinuingEdForm)
                this.ContinuingEdForm(container.Payload.ContinuingEdForm);
            if (container.Payload.DisplayName)
                this.DisplayName(container.Payload.DisplayName);
            if (container.Payload.Program)
                this.Program(container.Payload.Program);
            if (container.Payload.TextForAccept)
                this.AcceptButtonText(container.Payload.TextForAccept);
            if (container.Payload.TextForDecline)
                this.DeclineButtonText(container.Payload.TextForDecline);
            if (container.Payload.HoverOverTextForAcceptButton)
                this.AcceptButtonHoverTxt(container.Payload.HoverOverTextForAcceptButton);
            if (container.Payload.HoverOverTextForDeclineButton)
                this.DeclineButtonHoverTxt(container.Payload.HoverOverTextForDeclineButton);
            if (container.Payload.ExpandInitial)
                this.ExpandInitial(container.Payload.ExpandInitial);
            this.EntryPoint(container.Payload.EntryPoint);
            if (container.Payload.AdmissionsDocuments) {
                viewModel.AdmissionsDocuments.items([]);
                jQuery.each(container.Payload.AdmissionsDocuments, function () {
                    sm.portal.vm.custom.callCustomization('AdmissionsDocumentsCustom',this[0])
                    viewModel.AdmissionsDocuments.push(this[0].DocumentName, this);
                });
            }
            if (container.Payload.AdmissionsOffer && container.Payload.AdmissionsOffer.AdmissionsOffer) {
                this.GetRichTextStatus(container.Payload.AdmissionsOffer.RichTextField);
                if(!self.IsEmptyRichText()){
                    this.AdmissionOfferRichText(container.Payload.AdmissionsOffer.RichTextField);
                }
                this.AdmissionsOffer.items([]);
                this.AdmissionsOffer.push('Admissions Offer', container.Payload.AdmissionsOffer.AdmissionsOffer);
            }
            this.ShowFacultyCommunication = ko.observable(false);
            this.SendCommunicationData = ko.observable(new sm.portal.vm.SendCommunicationViewModel());

            if(container.Payload.HeaderTextOfferResponseSection != ''){
                this.HandleEncryptedRichText(container.Payload.HeaderTextOfferResponseSection, this.HeaderTextVisible, this.HeaderText);
            }

            if(container.Payload.PostAcceptanceText !== ''){
                this.HandleEncryptedRichText(container.Payload.PostAcceptanceText, this.PostAcceptanceTextVisible, this.PostAcceptanceText);
            }

            if(container.Payload.PostDeclineText !== ''){
                this.HandleEncryptedRichText(container.Payload.PostDeclineText, this.PostDeclineTextVisible, this.PostDeclineText);
            }

            if (container.Payload.TermsConditions) {
                var termsModel = new sm.portal.vm.TermsConditionsViewModel('AfterTerms', container, null);
                termsModel.LoadModel(container);
                this.TermsAndCondition(termsModel);
                this.TermsAndConditionLoaded(true);
            };

            if (container.Payload.IsPaymentProviderEnabled !== undefined)
            {
                this.GetPaymentProviderName();
                self.IsPaymentProviderEnabled(container.Payload.IsPaymentProviderEnabled);
            }
            if (container.Payload.BiilingDomicileSettings !== undefined) {
                self.IsBillingDomicileMappingCorrect(container.Payload.BiilingDomicileSettings.IsBillingDomicileMappingCorrect);
                self.BillingDomicileMessage(container.Payload.BiilingDomicileSettings.BillingDomicileMessage);
                self.IsBillingDomicilePaymentProviderEnabled(container.Payload.BiilingDomicileSettings.IsBillingDomicilePaymentProviderEnabled);
                self.BillingDomicilePaymentProviders(container.Payload.BiilingDomicileSettings.PaymentProviders);
            }            
            if (container.Payload.PostSubmissionFlowSettings == "Custom" && container.Payload.ApplicationFee.length > 0 && !container.Payload.ApplicationFee[0]?.Paid) {
                self.SubmittedWithPostSubmissionFlowCustom(true);
            }
            else {
                self.SubmittedWithPostSubmissionFlowCustom(false);
            }
            if (container.Payload.AdmissionsAdditionalInformations)
                this.AdmissionsAdditionalInformations(container.Payload.AdmissionsAdditionalInformations);

            let updatedSections = this.AdmissionsAdditionalInformations().map((section) => {
                // Create a copy of the current section object to avoid modifying the original directly
                let updatedSection = { ...section };
                
                // Update the InformationContent field with the modified version
                updatedSection.InformationContent = this.GetSectionHtml(section);
                return updatedSection;
                });

                // Update the AdmissionsAdditionalInformations with the modified sections
                this.AdmissionsAdditionalInformations(updatedSections);

            //Changes to show Initial Additional information accordian as expanded   value when toggle is on
            if (this.AdmissionsAdditionalInformations().length > 0 && this.ExpandInitial())
                self.AdditionalInfoExpandInitial();
            //Changes for APOI title
            if (container.Payload.OfferingItem && container.Payload.DisplayAPOIinsteadofAdmissionsProgram) {
                this.OfferingItem(container.Payload.OfferingItem);
                this.DisplayAPOI(container.Payload.DisplayAPOIinsteadofAdmissionsProgram);
            }
            else{
                this.OfferingItem(container.Payload.Program);
            }
            this.IsBackgroundProcessing(container.Payload.AdmissionsStageGID === container.Payload.AdmissionsStageConsts_BackgroundProcessingGuid);
            this.IsBackgroundProcessingError(container.Payload.AdmissionsStageGID === container.Payload.AdmissionsStageConsts_BackgroundProcessingErrorGuid);
        };

        this.PageReady = function () {
            sm.portal.ui.readyPage();
        };

        self.GetSectionHtml = function (section) {
            
            if (!section || !section.InformationContent || !Array.isArray(section.PlaceholderFieldsDetails)) {
                return ""; // Return an empty string or handle it as appropriate
            }

            // Split the InformationContent into content sections (defaulting to an empty string if undefined)
            let contentSections = (section.InformationContent || "").split('\n\n');
            let modifiedSections = [];
            
            contentSections.forEach((sectionContent) => {
                // Iterate over each placeholder detail in the section
                for (let i = 0; i < section.PlaceholderFieldsDetails.length; i++) {
                    let placeholderDetail = section.PlaceholderFieldsDetails[i];
                    
                    if (placeholderDetail.Name != null && placeholderDetail.Value != null) {
                        let placeholderPattern = new RegExp(`\\[\\[@PlaceholderFields_\\d+\\.${placeholderDetail.Name}\\]\\]`, 'g');
                        
                        if (placeholderPattern.test(sectionContent)) {
                            sectionContent = sectionContent.replace(placeholderPattern, placeholderDetail.Value);
                        }
                    }
                }

                // After processing, add the updated section content to the result array
                modifiedSections.push(sectionContent);
            });
        
            // Join the modified sections back together into the final content, separated by double newlines
            let updatedContent = modifiedSections.join('\n\n');
            return updatedContent;
        };
        self.AdditionalInfoExpandInitial = function () {
            var listFind1 = jQuery('.widgetContent').find('.additionalInformations > li').first();
            var listFind2 = jQuery('.widgetContent').find('.additionalInformations').find('.itemDetails').first();
            var iconBtn = listFind1.find('.detailsIcon');
            listFind1.addClass('detailsShowing');
            listFind2.addClass('active');
            iconBtn.addClass('hide');
        }

        self.PaymentProviderSelectionPopupForDeposit = function () {
            this.IsDepositPayment(true);
            this.PaymentProviderSelectionPopup();
        }
        self.PaymentProviderSelectionPopupForPayment = function () {
            this.IsDepositPayment(false);
            this.PaymentProviderSelectionPopup();
        }

        self.PaymentProviderSelectionPopup = function(){
            jQuery.blockUI();
            var isDepositPayment = this.IsDepositPayment();
            function GenerateHTMLForPaymentMethods(){  
                var result =  
                '<p style="padding-top: 10px; margin: 0">'+ sm.portal.utility.getResourceValue('DomicilePaymentSelectionHeading') +'</p>';
                if(self.BillingDomicilePaymentProviders().length > 0){
                    for(var i = 0; i < self.BillingDomicilePaymentProviders().length; i++){
                        result = result + 
                        '<div class="fieldGroup radioLabel">' +
                        '<div class="field">' + 
                        '<div style="float:left">' + 
                        '<label for=' + self.BillingDomicilePaymentProviders()[i].ID + '>' + 
                        '<input type="radio" name="radioPayment" id= ' + self.BillingDomicilePaymentProviders()[i].ID + ' value= '+ self.BillingDomicilePaymentProviders()[i].Name+ ' />' +
                        '<span>' + self.BillingDomicilePaymentProviders()[i].Name + '</span>' +
                        '</label>' +
                        '</div>' +
                        '</div>' +
                        '</div>'
                    }
                }
                return result
            }
            var bodyContent = GenerateHTMLForPaymentMethods();
            var buttonContent = '<button class="cancelBtn" onclick="sm.portal.vm.closeModal(\'Cancel\');" >' + sm.portal.utility.getResourceValue('Cancel') + '</button>';
            if (isDepositPayment) {
                buttonContent = buttonContent + '<button id="MakeDepositPaymentbtn" class="confirmBtn f-right" disabled >' + sm.portal.utility.getResourceValue('MakePayment') + '</button>';
            }
            else {
                buttonContent = buttonContent + '<button id="MakePaymentbtn" class="confirmBtn f-right" disabled >' + sm.portal.utility.getResourceValue('MakePayment') + '</button>';
            }

            sm.portal.ui.lightBox(sm.portal.utility.getResourceValue('MakePayment'), bodyContent, 'smallDialog', null, null, buttonContent);
            jQuery.unblockUI();

            jQuery('input[name="radioPayment"]').on('change', function() {
                // Check if this checkbox is being checked (not unchecked)
                if (jQuery(this).is(':checked')) {
                    changeConfirmButtonEnable();
                }
            })

            jQuery('#MakePaymentbtn').click(function () {
                getSelectedPaymentProvider();
                if (self.PaymentProviderName() === "FlywireV2") {
                    jQuery("#flywireVisibleButton").click();
                }else if(self.PaymentProviderName() === "Flywire"){
                    jQuery("#flywireButton").click();
                } else
                    jQuery('button[data-payment-button]')[0].click();
            });
            jQuery('#MakeDepositPaymentbtn').click(function () {
                getSelectedPaymentProvider();
                if (self.PaymentProviderName() === "FlywireV2") {
                    jQuery('#depositPaymentFlywire').children().each(function () {
                        if (jQuery(this).attr('id') === 'flywireVisibleButton') {
                            jQuery(this).trigger('click');
                        }
                    });
                } else if (self.PaymentProviderName() === "Flywire") {
                    jQuery('#depositPayment').children().each(function () {
                        if (jQuery(this).prop('tagName').toUpperCase() === 'BUTTON') {
                            jQuery(this).trigger('click');
                        }
                    });
                } else jQuery('button[data-deposit-payment-button]')[0].click();

            });

            var changeConfirmButtonEnable = function () {
                var canBeEnabled = !jQuery('#amount-required').hasClass('active') && !jQuery('#amount-min-max-check').hasClass('active');;
                if (canBeEnabled) {
                    if (document.getElementById("MakeDepositPaymentbtn")) {
                        jQuery('#MakeDepositPaymentbtn').removeAttr('disabled');
                    }
                    else
                        jQuery('#MakePaymentbtn').removeAttr('disabled');

                } else {
                    if (document.getElementById("MakeDepositPaymentbtn")) {
                        jQuery('#MakeDepositPaymentbtn').attr('disabled', '');
                    }
                    else
                        jQuery('#MakePaymentbtn').attr('disabled', '');

                }
            }
            var getSelectedPaymentProvider = function () {
                var selectedPaymentProvider = jQuery('input[name="radioPayment"]:checked');
                var selectedPaymentProviderName = selectedPaymentProvider.attr('value');
                var selectedPaymentProviderId = selectedPaymentProvider.attr('id');
                self.PaymentProviderName(selectedPaymentProviderName);
                self.SelectedPaymentProviderId(selectedPaymentProviderId);
                sm.portal.ui.removeLightbox();
            }
        }

        this.SetDefaultStatusTranscript = function(data) {
            if (data && data.AdmissionsRequirementGroups && data.AdmissionsRequirementGroups.length > 0) {
                data.AdmissionsRequirementGroups.forEach(rec => {
                    rec.Status = 'Evaluated';
                    if (rec.AdmissionsRequirementSubGroup && rec.AdmissionsRequirementSubGroup.length > 0) {
                        rec.AdmissionsRequirementSubGroup.forEach(subRec => {
                            subRec.Status = 'Evaluated';
                        });
                    }                            
                });
            }
            return data;
        }

        this.DataSetupTranscriptGradeEvaluation = function(data) {
            if (data && data.AdmissionsRequirementGroups && data.AdmissionsRequirementGroups.length > 0) {
                for (const key in data.StatusDictionary) {
                    if(data.StatusDictionary.hasOwnProperty(key)) {
                        data.AdmissionsRequirementGroups.forEach(rec => {
                            if (rec.GID == key) {
                                rec.Status = data.StatusDictionary[key];
                            } else if (rec.AdmissionsRequirementSubGroup && rec.AdmissionsRequirementSubGroup.length > 0) {
                                rec.AdmissionsRequirementSubGroup.forEach(subRec => {
                                    if (subRec.GID == key) {
                                        subRec.Status = data.StatusDictionary[key];
                                    }
                                });
                            }                            
                        });
                    }
                }
            }
            return data;
        }

        this.AssignRuleTypeMergeSubGroupToCourse = function(data) {
            if (data && data.AdmissionsRequirementGroups && data.AdmissionsRequirementGroups.length > 0) {
                data.AdmissionsRequirementGroups.forEach(rec => {
                    if (rec.Courses && rec.Courses.length > 0) {
                        rec.Courses.forEach(course => {
                            this.ValuesAssignmentToRules(course);
                        });
                    }
                    if (rec.Tests && rec.Tests.length > 0) {
                        rec.Tests.forEach(grptest => {
                            this.ValuesAssignmentToTestRules(grptest);
                        });
                    }
                
                    if (rec.AdmissionsRequirementSubGroup && rec.AdmissionsRequirementSubGroup.length > 0) {
                        rec.AdmissionsRequirementSubGroup = this.consolidateSubGroups(rec.AdmissionsRequirementSubGroup);
                        rec.AdmissionsRequirementSubGroup.forEach(subRec => {
                            if (subRec.Courses && subRec.Courses.length > 0) {
                                subRec.Courses.forEach(subGrpCourse => {
                                    this.ValuesAssignmentToRules(subGrpCourse);
                                });
                            }
                            if (subRec.Tests && subRec.Tests.length > 0) {
                                subRec.Tests.forEach(subGrpTest => {
                                    this.ValuesAssignmentToTestRules(subGrpTest);
                                });
                            }
                        });
                    }                            
                });
            }
            return data;
        }

        this.ValuesAssignmentToRules = function(course) {
            if (course && course.RuleTypeDisplayName && course.RuleTypeBusinessMeaningName) {
                if (course.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.MinNumericGrade' || course.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.MinPercentageGrade') {
                    course.RuleTypeDisplayName = sm.portal.utility.formatString(course.RuleTypeDisplayName, course.MinPassingScore); // >={0}
                } else if (course.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.NumericGradeRange') {
                    course.RuleTypeDisplayName = sm.portal.utility.formatString(course.RuleTypeDisplayName, course.MinPassingScore, course.MaxPassingScore); // >={0} & <={1}
                }
            }
        }

        this.ValuesAssignmentToTestRules = function (test) {
            if (test.TestField && test.TestField.length > 0) {
                    test.TestField.forEach(testField => {
                        if (testField && testField.RuleTypeDisplayName && testField.RuleTypeBusinessMeaningName) {
                            if (testField.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.MinNumericGrade' || testField.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.MinPercentageGrade') {
                                testField.RuleTypeDisplayName = sm.portal.utility.formatString(testField.RuleTypeDisplayName, testField.MinPassingScore); // >={0}
                            } else if (testField.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.NumericGradeRange') {
                                testField.RuleTypeDisplayName = sm.portal.utility.formatString(testField.RuleTypeDisplayName, testField.MinPassingScore, testField.MaxPassingScore); // >={0} & <={1}
                            }else if (testField.RuleTypeBusinessMeaningName === 'AdmissionsRequirementRuleType.TestDate') {
                                testField.RuleTypeDisplayName = sm.portal.utility.formatString(testField.RuleTypeDisplayName, testField.StartDate, testField.EndDate); // date range
                            }
                        }
                    });
                }
           
        }

        this.consolidateSubGroups = function (subGroup) {
            const subGroupWithParent = subGroup.filter(sg => sg.ParentSubGroupGID).map(sgp => {
                const sgpCourses = sgp.Courses.map(course => {
                    return  {...course, SubGroupName: sgp.Name};
                });
                sgp.Courses = sgpCourses;
                return sgp;
            });
            const subGroupTestWithParent = subGroup.filter(sg => sg.ParentSubGroupGID).map(sgt => {
                const sgpTests = sgt.Tests.map(tests => {
                    return { ...tests, SubGroupName: sgt.Name };
                });
                sgt.Tests = sgpTests;
                return sgt;
            });

            subGroup = subGroup.filter(sg => !sg.hasOwnProperty('ParentSubGroupGID')).map(sgwpt => {
                const sgwpTests = sgwpt.Tests.map(tests => {
                    return { ...tests, SubGroupName: sgwpt.Name };
                });
                sgwpt.Tests = sgwpTests;
                
                return sgwpt;
            });

            if (subGroupTestWithParent && subGroupTestWithParent.length > 0) {
                subGroup.forEach(sg => {
                    subGroupTestWithParent.forEach(sgp => {
                        if (sg.GID === sgp.ParentSubGroupGID) {
                            sg.Tests = [...sg.Tests, ...sgp.Tests]
                        }
                    });
                })
                
            }

            subGroup = subGroup.filter(sg => !sg.hasOwnProperty('ParentSubGroupGID')).map(sgwp => {
                const sgwpCourses = sgwp.Courses.map(course => {
                    return {...course, SubGroupName: sgwp.Name};
                });
                sgwp.Courses = sgwpCourses;
                return sgwp;
            });
            if (subGroupWithParent && subGroupWithParent.length > 0) {
                subGroup.forEach(sg => {
                    subGroupWithParent.forEach(sgp => {
                        if (sg.GID === sgp.ParentSubGroupGID) {                        
                            sg.Courses = [...sg.Courses, ...sgp.Courses]
                        }
                    });
                })
            }
            return subGroup;
        }
      
        this.LoadInitialData = function () {
            var url = _baseApiUri + 'api/studentdocumentchecklist/get/?gid=' + AdmissionsAttemptGID + '&recordid=0'; // RB - Moved to global variable, loaded from WordPress 43376;
            sm.portal.page.documentChecklist.doGet(url);
            this.AllTestScoreTemplate('AllTestScoreTemplate');
            this.AcceptAndDeclineButton('AcceptAndDeclineButton');
            this.RequiredDocumentTemplate('RequiredDocumentTemplate');
        };

        this.Accept = function (admission, event) {
            if (self.IsConfirmPopupEnabled()) {
                var message = sm.portal.utility.getResourceValue('AcceptPopupMesg');
                var title = sm.portal.utility.getResourceValue('Confirm');

                sm.portal.ui.lightBox(
                    title,
                    message,
                    ' smallDialog',
                    function () {
                        jQuery('.confirmBtn').on('click',
                            function () {
                                self.acceptConfirm(admission, event);
                                sm.portal.ui.removeLightbox();
                                self.ShowPostAcceptanceDeclinePopup(self.PostAcceptanceTextVisible(), self.PostAcceptanceText());
                            });
                    },
                    null,
                    '<button title="' + sm.portal.utility.getResourceValue('Cancel') + '" data-close-lightbox>' +
                    sm.portal.utility.getResourceValue('No') +
                    '</button>' +
                    '<button title="' + sm.portal.utility.getResourceValue('OK') + '" class="confirmBtn">' +
                    sm.portal.utility.getResourceValue('Yes') +
                    '</button>'
                );
            }
            else {
                self.AcceptOrDeclineAdmissions(admission, event, true);
                self.ShowPostAcceptanceDeclinePopup(self.PostAcceptanceTextVisible(), self.PostAcceptanceText());
            }

        };

        this.acceptConfirm = function (admission, event) {
            self.AcceptOrDeclineAdmissions(admission, event, true);
        };

        this.ShowPostAcceptanceDeclinePopup = function(showPopup, message){
            if(showPopup){
                var title = sm.portal.utility.getResourceValue('Information');
    
                sm.portal.ui.lightBox(
                    title,
                    message,
                    ' smallDialog',
                    function () {
                        jQuery('.confirmBtn').on('click',
                            function () {
                                sm.portal.ui.removeLightbox();
                            });
                    },
                    null,
                    '<button title="' + sm.portal.utility.getResourceValue('OK') + '" class="confirmBtn">' +
                    sm.portal.utility.getResourceValue('OK') +
                    '</button>'
                );
            }
        }

        this.CanStudentAcceptOffer = ko.computed(function () {

            if (this.StudentHasAcceptedOffer()) {
                return false;
            };

            if (this.TermsAndConditionLoaded() && !this.TermsAndCondition().Completed()) {
                return false;
            };

            return true;
        }, this);

        this.ShouldTermsConditionsBeDisplayed = ko.computed(function () {
            if (this.TermsAndConditionLoaded() && this.CurrentAdmissionStageHasOffer()) {
                return true;
            }
            return false;
        }, this);

        this.HasAnyTestScores = ko.computed(function () {
            return this.ACTScore().length > 0
                || this.SATScore().length > 0
                || this.PraxisScore().length > 0
                || this.PraxisIIScore().length > 0
                || this.GEDScore().length > 0
                || this.GREScore().length > 0
                || this.GMATScore().length > 0
                || this.TOEFL().length > 0;
        }, this);

        this.Decline = function (admission, event) {
            if (self.IsConfirmPopupEnabled()) {
                var message = sm.portal.utility.getResourceValue('DeclinePopupMesg');
                var title = sm.portal.utility.getResourceValue('Confirm');
               
                sm.portal.ui.lightBox(
                    title,
                    message,
                    ' smallDialog',
                    function () {
                        jQuery('.confirmBtn').on('click',
                            function () {
                                self.declineConfirm(admission, event);
                                sm.portal.ui.removeLightbox();
                                self.ShowPostAcceptanceDeclinePopup(self.PostDeclineTextVisible(), self.PostDeclineText());
                            });
                    },
                    null,
                    '<button title="' + sm.portal.utility.getResourceValue('Cancel') + '" data-close-lightbox>' +
                    sm.portal.utility.getResourceValue('No') +
                    '</button>' +
                    '<button title="' + sm.portal.utility.getResourceValue('OK') + '" class="confirmBtn">' +
                    sm.portal.utility.getResourceValue('Yes') +
                    '</button>'
                );
            }
            else {
                self.AcceptOrDeclineAdmissions(admission, event, false);
                self.ShowPostAcceptanceDeclinePopup(self.PostDeclineTextVisible(), self.PostDeclineText());
            }
        };
        this.declineConfirm = function (admission, event) {
            self.AcceptOrDeclineAdmissions(admission, event, false);
        };
        this.adHocDocumentBtnClick = function () {

            jQuery.blockUI();

            var msgSubject = sm.portal.utility.formatString(sm.portal.utility.getResourceValue('Person0RequestsReUploadOf1'), self.DisplayName(), event.currentTarget.id);
            var newMsg = new sm.portal.vm.SendCommunicationViewModel();
            newMsg.DisplayName(viewModel.DisplayName());
            newMsg.ToAddress("U4SM.imap@unit4.com"); // Needs to be reworked to be from the app settings
            newMsg.FromAddress("TEMP");
            newMsg.ContextID(viewModel.PersonID);
            newMsg.CurrentUserID(_currentPersonId);
            newMsg.Html("");
            newMsg.Subject(msgSubject);

            viewModel.SendCommunicationData(newMsg);
            newMsg.SendMessage();
        };

        this.AcceptOrDeclineAdmissions = function (admission, event, accept) {
            jQuery.blockUI();
            var data = this.ExtractATO(accept);
            url = _baseApiUri + 'api/studentdocumentchecklist/AcceptOrDeclineOffer/';
            jQuery.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: jQuery.proxy(function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        this.AdmissionsStage(container.Payload.AdmissionsStage);
                        this.CurrentAdmissionStageHasOffer(container.Payload.CurrentAdmissionStageHasOffer);
                        this.StudentHasAcceptedOffer(container.Payload.StudentHasAcceptedOffer);
                        this.StudentHasDeniedOffer(container.Payload.StudentHasDeniedOffer);
                        this.AdmissionsAdditionalInformations(container.Payload.AdmissionsAdditionalInformations);
                        if (container.Payload.ExpandInitial)
                            this.ExpandInitial(container.Payload.ExpandInitial);
                        if (this.AdmissionsAdditionalInformations().length > 0 && this.ExpandInitial())
                            self.AdditionalInfoExpandInitial();
                    } else if (data.Status === 'validationerror') {
                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                        // TODO: Identify and highlight the associated fields (if possible)

                    } else if (data.Status === 'error') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    jQuery.unblockUI();
                    sm.portal.ui.readyPage();
                }, admission),
                error: function (jqXHR, exception) {
                    if (jqXHR.status === 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        viewModel.HandleError(title, [body]);
                    } else if (jqXHR.status === 400) {
                        viewModel.HandleError(exception + jqXHR.responseJSON.Message);
                    }
                    else {
                        viewModel.HandleError(exception);
                    }
                    jQuery.unblockUI();
                }
            });
        };

        this.ClearUploadDocumentInit = function (attemptGID, data, event) {

            var fileElement = ClearUploadArea(event.target);
            var documentID = 0;

            if (data.model.TranscriptDocumentID !== undefined) {
                documentID = data.model.TranscriptDocumentID;
            }
            else {
                documentID = data.model.ID;
            }

            var url = _baseApiUri + "api/studentdocumentchecklist/ClearDocumentFile?documentID=" + documentID + "&attemptGID=" + attemptGID;
            var formData = new FormData();

            jQuery.ajax({
                type: "POST",
                url: url,
                contentType: false,
                processData: false,
                crossDomain: true,
                data: formData,
                headers: {
                    "x-api-version": '1'
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {                 
                    jQuery("#CurrentUploadID").val("");

                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    self.LoadModel(container);

                    sm.portal.ui.readyPage();
                    sm.portal.ui.successIndicator(fileElement, data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    self.HandleError(exception);
                }
            });
        };

        this.HandleError = function (title, messages) {
            this.IsError(true);
            this.IsGeneralError(true);
            jQuery.unblockUI();
            if (messages) {
                this.ErrorMessages(messages);
            }
            if (sm.portal.utility.isNullOrEmpty(title)) {
                viewModel.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            } else {
                viewModel.ErrorHeader(title);
            }
        };

        this.GetPaymentProviderName = function () {
            if (viewModel.IsPaymentProviderEnabled) {
                var url = _baseApiUri + sm.portal.utility.formatString('api/portalstudentledger/GetPaymentProviderName');
                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1'
                    },
                    processData: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        viewModel.PaymentProviderName(data);
                    },
                    error: function (exception) {
                        viewModel.HandleError(exception);
                    }
                });
            }
        };

        // Extraction Method
        this.ExtractATO = function (accepted) {
            var submitObject = ko.mapping.toJS(this);

            var termsData = null;
            if (!sm.portal.utility.isNullOrEmpty(self.TermsAndCondition())) {
                termsData = self.TermsAndCondition().ExtractATO();
            }

            var submitModel = {
                AdmissionsAttemptGid: self.AdmissionsAttemptGid(),
                AdmissionsAccepted: accepted,
                TermsData: ko.toJS(termsData)
            };

            return submitModel;
        };

        return self;
    }

    function ClearUploadArea(element) {

        var uploadArea = jQuery(element).closest('.uploadArea');
        var uploadBox = uploadArea.find('.uploadBox');
        var fileElement = uploadBox.find('input[type="file"]');
        var fileThumb = uploadArea.find('div.fileThumb');

        fileThumb.removeClass('active');
        fileThumb.addClass('hidden');
        uploadBox.removeClass('hidden');

        sm.portal.ui.loadingIndicator(fileElement);

        return fileElement;
    }

    jQuery.extend(true, sm.portal.vm, {
        DocumentListViewModel: DocumentListViewModel,
    });

})(jQuery);